module.exports = __webpack_public_path__ + "img/securite_ludinam_2017.7f51c617.jpg";